<section *ngIf="title" class="unauthorized mat-elevation-z3">
  <img [src]="'assets/images/icons/' + icon" [class]="icon.includes('hand') ? 'unauthorized__icon':''" [alt]="icon"/>

  <h1 class="unauthorized__title">{{ title }}</h1>
  <p class="unauthorized__paragraph" [innerHTML]="paragraph"></p>

  <button mat-flat-button color="warn" (click)="logOut()" class="unauthorized__action">{{ button }}</button>

  <p class="unauthorized__advise" [innerHTML]="advise"></p>
</section>
